'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dCorrespondent from "./app.api.-Drug-Request-Correspondent.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestCorrespondent$GeneralPractice(details) {
  this.Lapp_api_DrugRequestCorrespondent$GeneralPractice__f_details = null;
  this.Lapp_api_DrugRequestCorrespondent$GeneralPractice__f_details = details;
}
export { $c_Lapp_api_DrugRequestCorrespondent$GeneralPractice as $c_Lapp_api_DrugRequestCorrespondent$GeneralPractice };
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype = new $j_app$002eapi$002e$002dDrug$002dRequest$002dCorrespondent.$h_Lapp_api_DrugRequestCorrespondent();
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.constructor = $c_Lapp_api_DrugRequestCorrespondent$GeneralPractice;
/** @constructor */
function $h_Lapp_api_DrugRequestCorrespondent$GeneralPractice() {
}
export { $h_Lapp_api_DrugRequestCorrespondent$GeneralPractice as $h_Lapp_api_DrugRequestCorrespondent$GeneralPractice };
$h_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype = $c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype;
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-733039064), true);
});
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestCorrespondent$GeneralPractice)) {
    var x = this.Lapp_api_DrugRequestCorrespondent$GeneralPractice__f_details;
    var x$2 = x$0.Lapp_api_DrugRequestCorrespondent$GeneralPractice__f_details;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.productPrefix__T = (function() {
  return "GeneralPractice";
});
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_DrugRequestCorrespondent$GeneralPractice__f_details;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "details";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_DrugRequestCorrespondent$GeneralPractice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestCorrespondent$GeneralPractice)));
}
export { $isArrayOf_Lapp_api_DrugRequestCorrespondent$GeneralPractice as $isArrayOf_Lapp_api_DrugRequestCorrespondent$GeneralPractice };
var $d_Lapp_api_DrugRequestCorrespondent$GeneralPractice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestCorrespondent$GeneralPractice, "app.api.DrugRequestCorrespondent$GeneralPractice", ({
  Lapp_api_DrugRequestCorrespondent$GeneralPractice: 1,
  Lapp_api_DrugRequestCorrespondent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_DrugRequestCorrespondent$GeneralPractice as $d_Lapp_api_DrugRequestCorrespondent$GeneralPractice };
//# sourceMappingURL=app.api.-Drug-Request-Correspondent$-General-Practice.js.map
